import React from "react";
import { StateContext } from "../hooks/useStateContext";
import { useLoggingReducer } from "../hooks/useLoggingReducer";

export interface IProviderProps {
  children: React.ReactNode;
}

export function StateProvider({ children }: IProviderProps) {
  const [state, dispatch] = useLoggingReducer();

  return (
    <StateContext.Provider value={{ state, dispatch }}>
      {children}
    </StateContext.Provider>
  );
}
